import axios from 'axios'
import { apiObject } from './apiobject'

const problems = {
  ...apiObject,
  url: '/notifications/smsproblems/',
  downloadCsv ({ search = null, ordering = null, filter = {} } = {}) {
    var paramObject = Object.assign({format: 'csv', count: 99999}, { search, ordering }, filter)
    return axios.get(`${this.url}`, {
      params: paramObject,
      responseType: 'arraybuffer'
    })
  }
}

const unknownSMS = {
  ...apiObject,
  url: '/notifications/unknownsms/',
  downloadCsv ({ search = null, ordering = null, filter = {} } = {}) {
    var paramObject = Object.assign({format: 'csv', count: 99999}, { search, ordering }, filter)
    return axios.get(`${this.url}`, {
      params: paramObject,
      responseType: 'arraybuffer'
    })
  }
}

export default {
  problems,
  unknownSMS
}
